import * as PropTypes from 'prop-types';
import React from 'react';

import Banner, {BannerProps, MessageLevel} from 'ui-library/banners/Banner';

export type ErrorBannerProps = Pick<BannerProps, 'children'>;

/**
 * Renders a full width error banner with a message.
 *
 * @deprecated Please use client/ui-library/banners/InlineBanner instead
 */
export default function ErrorBanner(props: ErrorBannerProps): JSX.Element {
  return <Banner {...props} level={MessageLevel.ERROR} />;
}

export const ERROR_BANNER_PROPS = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
};
